import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleExclamation,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { setToast } from "../../redux/slice/toast.slice";
import "./index.css";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { safeText } from "../../utils/safeText";

let timeoutId = "";

/**
 * CustomToast Component
 * Displays custom toast notifications for success and error messages
 * 
 * @param {Object} props - Component props
 * @param {string|string[]} props.message - Toast message text or array of error messages
 * @param {boolean} props.success - Whether to show success toast
 * @param {boolean} props.error - Whether to show error toast
 */
export function CustomToast({ message, success, error }) {
  const dispatch = useDispatch();

  const clearToast = useCallback(() => {
    clearTimeout(timeoutId);
    dispatch(setToast({ message: "", success: false, error: false }));
  }, [dispatch]);

  useEffect(() => {
    if (message !== "") {
      timeoutId = setTimeout(() => {
        clearToast();
      }, 3000);
    }
  }, [message, success, error, clearToast]);

  return (
    <div>
      {success === true && message !== "" && (
        <div id="snackbarSuccess" className={"show"} style={{zIndex:999}}>
          <div className="main-container">
            <div className="snak-icon">
              <CheckOutlined style={{
                color: "white"
              }} />
              {/* <FontAwesomeIcon size={"2x"} icon={faCircleCheck} color="white" /> */}
            </div>
            <div className="snak-message">
              <p className="message-text">{safeText(message)}</p>
            </div>
            <div className="close-btn" onClick={() => clearToast()}>
              {/* CLOSE */}
              <CloseOutlined />
              {/* <FontAwesomeIcon size={"2x"} color="white" icon={faXmark} /> */}
            </div>
          </div>
        </div>
      )}
      {error === true && (
        <>
          {Array.isArray(message) ? (
            <div id="snackbarError" className={"show"}>
              <div className="main-container">
                <div className="snak-icon">
                  <FontAwesomeIcon
                    size={"2x"}
                    icon={faCircleExclamation}
                    color="white"
                  />
                </div>
                <div className="snak-message-error">
                  {Array.isArray(message) &&
                    message?.map((item, index) => (
                      <p key={index} className="message-text">
                        {safeText(item)}
                      </p>
                    ))}
                </div>
                <div className="close-btn" onClick={() => clearToast()}>
                  {/* CLOSE */}
                  <FontAwesomeIcon size={"2x"} color="white" icon={faXmark} />
                </div>
              </div>
            </div>
          ) : (
            <div id="snackbarError" className={"show"}>
              <div className="main-container">
                <div className="snak-icon">
                  <FontAwesomeIcon
                    size={"2x"}
                    icon={faCircleExclamation}
                    color="white"
                  />
                </div>

                <div className="snak-message-error">
                  <p className="message-text">{safeText(message)}</p>
                </div>
                <div className="close-btn" onClick={() => clearToast()}>
                  <FontAwesomeIcon size={"2x"} color="white" icon={faXmark} />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
